import { Link } from "react-router-dom";
import { Css, type Properties } from "src/Css";

export type LinkButtonProps = {
  children: React.ReactNode;
  to: string | { pathname: string; state: any };
  underline?: "none" | "hover" | "initial";
  xss?: Properties;
  onClick?: () => void;
};

export function LinkButton(props: LinkButtonProps) {
  const { children, to, underline = "hover", xss = {}, onClick } = props;

  const td = underline === "initial" ? "underline" : "none";
  const td_hover = underline === "hover" ? "underline" : "none";
  return (
    <Link
      css={{
        ...Css.textDecoration(td).gray700.cursorPointer.onHover.textDecoration(td_hover).$,
        ...xss,
      }}
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
